export default Object.freeze({
  REGULAR: 'REGULAR',
  SERVICE_COUNTER_PARENT: 'SERVICE_COUNTER_PARENT',
  SERVICE_COUNTER_DERIVATIVE: 'SERVICE_COUNTER_DERIVATIVE',
  PRODUCT_GROUP_PARENT: 'PRODUCT_GROUP_PARENT',
  PRODUCT_GROUP_DERIVATIVE: 'PRODUCT_GROUP_DERIVATIVE',
});
